var exports = {
  "zr": "AudioWaveform.module__root___S3Z4RT",
  "Ji": "AudioWaveform.module__canvas___S3Z4RT",
  "r1": "AudioWaveform.module__selection___S3Z4RT",
  "EP": "AudioWaveform.module__selectionDragging___S3Z4RT",
  "p$": "AudioWaveform.module__handle___S3Z4RT",
  "p_": "AudioWaveform.module__handleStart___S3Z4RT",
  "es": "AudioWaveform.module__handleEnd___S3Z4RT",
  "lG": "AudioWaveform.module__playhead___S3Z4RT",
};

module.exports = exports;
